interface IInjury {
    placeOccurred?: string;
    date?: string;
    time?: string;
    noticeDate?: string;
    cause?: string;
    nature?: string;
    type?: string;
    jobCorpsCenterId?: number;
}

class Injury implements IInjury {
    public placeOccurred?: string;
    public cause?: string;
    public nature?: string;
    public date?: string;
    public time?: string;
    public noticeDate?: string;
    public type?: string;
    public jobCorpsCenterId?: number;

    constructor(i: IInjury = {}) {
        this.placeOccurred = i.placeOccurred;
        this.cause = i.cause;
        this.nature = i.nature;
        this.date = i.date;
        this.time = i.time;
        this.noticeDate = i.noticeDate;
        this.type = i.type;
        this.jobCorpsCenterId = i.jobCorpsCenterId;
    }

    public isValid(): string[] {
        const validations: string[] = [];
        if (this.placeOccurred === undefined || this.placeOccurred.length === 0) {
            validations.push('placeOccurred');
        }
        if (this.date === undefined || this.date.length === 0) {
            validations.push('date');
        }
        if (this.time === undefined || this.time.length === 0) {
            validations.push('time');
        }
        if (this.noticeDate === undefined || this.noticeDate.length === 0) {
            validations.push('noticeDate');
        }
        if (this.cause === undefined || this.cause.length === 0) {
            validations.push('cause');
        }
        if (this.nature === undefined || this.nature.length === 0) {
            validations.push('nature');
        }
        return validations;
    }
}

export default Injury;
export { Injury, IInjury };
